import { FETCH_PERSON_ADDRESSES_DATA } from 'stores/redux/actions/types';
import reducer from '../common/reducer';

const addReducer = reducer(FETCH_PERSON_ADDRESSES_DATA);
export default addReducer;
